<template>
    <div class="container-fluid ">
        <b-row class="">
          <b-col md="3" >
            <h2 class="m-3 titlenews">
            {{$t('covid.cleantitle')}}
            </h2>
          </b-col>
          <b-col md="6"  class=" textnews">
            <div class="m-4">
            {{$t('covid.cleantext')}}
            <br><br>
            <router-link :to="{ name: 'Locations'}">{{$t('covid.wishrent')}}</router-link> {{$t('covid.findoffice')}}
           
            </div>  
          </b-col>
          <b-col md="3" class="text-center">
            <img v-if="$i18n.locale==='es'" class="mt-3" style="height:55%; widht:55%;" src="/img/cleanlogo.webp"/>
            <img v-else class="mt-3" style="height:55%; widht:55%;" src="/img/pledge_english.webp"/>
          </b-col>
        </b-row>

        <!-- content 2 -->
        <div class="">
        <b-row class="ml-3 mr-3 bggreen">
            <b-col md="6" class=" text-white align-self-center">
                <div class="text-center ">
                <br>
                <h2 class="titlepromo">{{$t('covid.completeclean')}}
                </h2> 
                <p class="textpromo mt-3">{{$t('covid.completetext')}}</p> 
                </div>
            </b-col>
            <b-col md="6" class="no-padding">
            <img 
            style="width:100%"
            class="" 
            src="/img/cleancar.webp"/>
            </b-col>
        </b-row>
        <!-- mobile changing -->
        <!-- <div class="d-none d-sm-none d-md-block">
        <b-row class="ml-3 mr-3 bggreen">
            <b-col md="6" class=" text-white align-self-center">
                <div class="text-center">
                <br>
                <h2 class="titlepromo">Estamos Abiertos & Siempre Disponibles
                </h2> 
                <p class="textpromo mt-3">Enterprise sigue abierto como un proveedor de servicios esenciales</p> 
                </div>
            </b-col>
            <b-col md="6" class="no-padding ">
            <img 
            style="width:100%"
            class="" 
            src="/img/oncall.webp"/>
            </b-col>
        </b-row>
        </div> -->
        <div class="d-lg-none d-xl-none">
        <!-- <b-row class="ml-3 mr-3 bggreen">
            <b-col md="6" class="no-padding ">
            <img 
            style="width:100%"
            class="" 
            src="/img/oncall.webp"/>
            </b-col>
            <b-col md="6" class=" text-white align-self-center">
                <div class="text-center">
                <br>
                <h2 class="titlepromo">Estamos Abiertos & Siempre Disponibles
                </h2> 
                <p class="textpromo mt-3">Enterprise sigue abierto como un proveedor de servicios esenciales</p> 
                </div>
            </b-col>
        </b-row> -->
        </div>
        <!-- end mobile changing -->
        <b-row class="ml-3 mr-3 bggreen">
            <b-col md="6" class="no-padding">
            <img 
            style="width:100%"
            class="" 
            src="/img/employees.webp"/>
            </b-col>

            <b-col md="6" class="bggreen text-white align-self-center">
                <div class="text-center">
                <br>
                <h2 class="titlepromo">{{$t('covid.protect')}}
                </h2> 
                <p class="textpromo mt-3">{{$t('covid.protecttext')}}</p> 
                </div>
            </b-col>
        </b-row>
        </div>
        <!-- content 2 mobile -->
        <div>
            <br><br>
            <h2 class="m-3 titlenews">
            {{$t('covid.cleantitle')}}
            </h2>
            <p class="m-3 textnews">
            {{$t('covid.completecleantext')}}
            <br><br>
            <b class="dinbold">{{$t('covid.vehicle')}}</b>
            <br><br>
            {{$t('covid.vehicletext')}}
            <br>
            {{$t('covid.cleantext')}}
            <b-row>
              <b-col md>
                <br><br><b class="dinbold"> · (1)</b> {{$t('covid.point1')}} 
                <br><br><b class="dinbold"> · (2)</b> {{$t('covid.point2')}}
                <br><br><b class="dinbold"> · (3)</b> {{$t('covid.point3')}}
                <br><br><b class="dinbold"> · (4)</b> {{$t('covid.point4')}}
                <br><br><b class="dinbold"> · (5)</b> {{$t('covid.point5')}}
                <br><br><b class="dinbold"> · (6)</b> {{$t('covid.point6')}}
                <br><br><b class="dinbold"> · (7)</b> {{$t('covid.point7')}}
                <br><br><b class="dinbold"> · (8)</b> {{$t('covid.point8')}}
                <br><br><b class="dinbold"> · (9)</b> {{$t('covid.point9')}}
                <br><br><b class="dinbold"> · (10)</b> {{$t('covid.point10')}} 
                <br><br><b class="dinbold"> · (11)</b> {{$t('covid.point11')}} 
                <br><br><b class="dinbold"> · (12)</b> {{$t('covid.point12')}} 
                <br><br><b class="dinbold"> · (13)</b> {{$t('covid.point13')}}
                <br><br><b class="dinbold"> · (14)</b> {{$t('covid.point14')}}
                <br><br><b class="dinbold"> · (15)</b> {{$t('covid.point15')}} 
                <br><br><b class="dinbold"> · (16)</b> {{$t('covid.point16')}} 
                <br><br><b class="dinbold"> · (17)</b> {{$t('covid.point17')}} 
                <br><br><b class="dinbold"> · (18)</b> {{$t('covid.point18')}} 
                <br><br><b class="dinbold"> · (19)</b> {{$t('covid.point19')}} 
                <br><br><b class="dinbold"> · (20)</b> {{$t('covid.point20')}} 
                <br><br><b class="dinbold"> ·     </b> {{$t('covid.point21')}}
                <br><br>
              </b-col>
              <b-col md>
                <img 
                style="width:100%"
                class="" 
                src="/img/auto-ptos-contacto.jpg"/>
              </b-col>
            </b-row>
            
            
            <b class="dinbold">{{$t('covid.offices')}}</b>
            <br><br>
            {{$t('covid.officestext')}}
            <br><br>
            <b class="dinbold">{{$t('covid.howhelp')}}</b>
            <br><br>
            {{$t('covid.howhelptext')}}
            <br><br>
            {{$t('covid.howhelptext1')}}
            <br><br> {{$t('covid.howhelptext2')}}
            <br><br> {{$t('covid.howhelptext3')}}
            <br><br> {{$t('covid.howhelptext4')}}
            <br><br> {{$t('covid.howhelptext5')}}
            <br><br> {{$t('covid.howhelptext6')}}
            <br><br> {{$t('covid.howhelptext7')}}
            </p>
        </div>
      <br>
      <div>

      </div>
    </div>
</template>
<script>

export default {
    name: 'covidnews'
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.dinregular{
  font-family: 'DIN 2014-Regular';
}
.dinbold{
  font-family: 'DIN 2014-ExraBold';
}
h2{
    margin:0;
}
.textnews{
color: #333333; 
font-family: 'DIN 2014-Regular', Arial, sans-serif;
font-size: 17px;
font-weight: 300;
}
.titlenews{
color: #333333; 
font-family: 'DIN 2014-Regular', Arial, sans-serif;
font-size: 32px;
font-weight: 700;
height: 74px;
margin: 0%;
}
.titlepromo{
font-family: 'DIN 2014-Regular', Arial, sans-serif;
font-size: 30px;
font-weight: 300;
}
.textpromo{
font-family: 'DIN 2014-Regular', Arial, sans-serif;
font-size: 17px;
font-weight: 400;
}
.bggreen{
    background-color: #169A5A;
}
.no-padding {
  padding-left: 0;
  padding-right: 0;
}
</style>

